import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-solid-svg-icons/faAngleDoubleRight';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Breadcrumbs } from 'ui-components/components/breadcrumbs';
import { Text } from 'ui-components/components/text';

import navItems, { findPageLabelFromLocation } from '../../nav-items';
import style from './style.module.less';

const getCategoryForPage = (pageLocation) => {
  const category = navItems.find((cat) => cat.items?.some((item) => item.location === pageLocation));

  return category ? { id: category.id, label: category.label } : null;
};

const SettingsBreadcrumbs = () => {
  const { pathname } = useLocation();
  const pieces = pathname.substring(1).split('/');

  const crumbs = [];

  pieces.forEach((location, index) => {
    const label = findPageLabelFromLocation(location);
    if (!label) {
      return;
    }

    if (index === pieces.length - 1) {
      const category = getCategoryForPage(location);

      if (category) {
        crumbs.push(<Text key={`category-${category.id}`} value={category.label} />);
      }

      crumbs.push(<Text key={location} value={label} />);
    } else {
      let linkTo = '';
      for (let i = 0; i <= index; i++) {
        linkTo += `/${pieces[i]}`;
      }

      crumbs.push(
        <Link key={location} color='inherit' to={linkTo}>
          {label}
        </Link>,
      );
    }
  });

  return (
    <div className={style.breadcrumbs}>
      <Breadcrumbs separator={<FontAwesomeIcon className={style.separator} icon={faAngleDoubleRight} />}>{crumbs}</Breadcrumbs>
    </div>
  );
};

export default SettingsBreadcrumbs;
